import React from "react";
import {
  SofturaTable,
  PrimaryButton,
  Label,
  Row,
  Col,
  ModalPopup,
} from "../../../../../CommonComponents";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import MoreOptions from "client/CommonComponents/MoreOptions";
import "../AppRoles.scss";
import { UseAppRoles } from "../hooks/useAppRoles";

interface IProps {
  setSelectedKey?: any;
  setSelectedRole: (event: any) => void;
  selectedRole?: any;
  appRoleName?: any;
  handleInfoModal?: any;
  showInfoModal?: any
}
const AppRoles = (props: IProps) => {
  const {
    showDeleteModal,
    option,
    handleDeleteModal,
    optionHandler,
    data,
    applicationList,
    handleChange,
    selectedApps,
    handleSubmit,
    closeDeleteModal,
    appRoleName,
    handleInfoModal,
    showInfoModal
  } = UseAppRoles(props);

  const columns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <>
            <MoreOptions
              onClick={optionHandler}
              options={option}
              {...row.rowData}
             data-attribute="AppRoles_Default_MoreOptions" />
          </>
        );
      },
      width: 50,
    },
    {
      key: "roleName",
      title: "Role Name",
      width: 200,
    },
    {
      key: "roleDescription",
      title: "Role Description",
      width: 200,
    },
    {
      key: "createdBy",
      title: "Created By",
      width: 200,
    },
    {
      key: "applicationName",
      title: "Application",
      width: 200,
    },
  ];

  return (
    <>
      <div className="app-grid-container pt-2">
        <div className="app-roles-head">
          <Row>
            <Label data-attribute="AppRoles_Default_Label">Application</Label>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} className="mb-3">
              <Dropdown
                placeholder="Select options"
                selectedKeys={selectedApps}
                multiSelect
                options={applicationList}
                onChange={handleChange}
               data-attribute="AppRoles_Default_Dropdown" />
            </Col>
            <Col xs={12} sm={12} md={2} lg={2} xl={2} className="mb-3">
              <PrimaryButton
                text="Search"
                className="pull-right"
                onClick={handleSubmit}
               data-attribute="AppRoles_Default_Button" />
            </Col>
          </Row>
        </div>
        <div
          className={
            data?.length !== 0 ? "softura-table" : "softura-table paginationNav"
          }
        >
          <SofturaTable
            data={data ?? []}
            columns={columns}
            sort={true}
            defaultPageSize={10}
            pageSizes={[10, 20, 50]}
            globalSearch={false}
            filter={true}
           data-attribute="AppRoles_Default_Grid" />
        </div>
      </div>
      {showDeleteModal ? (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete App Role"
          ModalPopupType="medium"
          FooterSecondaryBtnTxt="No"
          FooterPrimaryBtnTxt="Yes"
          closeModalPopup={closeDeleteModal}
          PrimaryBtnOnclick={handleDeleteModal}
          SecondryBtnOnclick={closeDeleteModal}
         data-attribute="AppRoles_Default_ModalPopup">
          <Label data-attribute="AppRoles_Default_Label_2">Are you sure you want to delete "{appRoleName}"?</Label>
        </ModalPopup>
      ) : (
        ""
      )}
      <div className="appPerInfo-Modal">
        {showInfoModal ? (
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="Information"
            ModalPopupType="medium"
            FooterPrimaryBtnTxt="Ok"
            closeModalPopup={handleInfoModal}
            PrimaryBtnOnclick={handleInfoModal}
           data-attribute="AppRoles_Default_ModalPopup_2">
            <Label data-attribute="AppRoles_Default_Label_3">Successfully deleted "{appRoleName}"</Label>
          </ModalPopup>
        ) : (
          ""
        )
        }
      </div>
    </>
  );
};

export default AppRoles;
